import { Remote } from "comlink";
import { GetState, SetState } from "zustand";
import { BetStore } from "..";
import isServer from "../../../libs/is-server";
import { Bet, BetRow } from "../../../types/bet";
import { IDBBetHandler } from "../../../workers/idb-bet-storer";
import { IDBBetSyncHandler } from "../../../workers/idb-bet-sync-handler";
import useAppStore, { ReductionRequirementView } from "../../app-store";
import uploadBet from "../upload-bet";

export const addFactorReduction = async (
  shouldUpdateReductionView: boolean,
  set: SetState<BetStore>,
  get: GetState<BetStore>,
  idbBetWorkerApi?: Remote<IDBBetHandler>,
  idbBetSyncWorkerApi?: Remote<IDBBetSyncHandler>
): Promise<void> => {
  const { bet } = get();

  const { currentBetId } = useAppStore.getState();

  if (!currentBetId || !bet) {
    return;
  }

  const { reductionRequirement } = bet;

  const addFactorReductionToRow = (row: BetRow): BetRow => {
    return {
      ...row,
      factorReduction: row.order.map(() => 1),
    };
  };

  const newBet: Bet = {
    ...bet,
    reductionRequirement: {
      ...reductionRequirement,
      factorReduction: {
        name: undefined,
      },
    },
    rows: bet.rows.map(addFactorReductionToRow),
  };

  set({
    bet: newBet,
    uploading: true,
  });

  if (shouldUpdateReductionView) {
    useAppStore
      .getState()
      .setReductionRequirementView(ReductionRequirementView.FACTOR);
  }

  if (!isServer) {
    uploadBet(
      currentBetId,
      newBet,
      () => set({ uploading: false }),
      idbBetSyncWorkerApi
    );

    if (idbBetWorkerApi) idbBetWorkerApi.storeBet(currentBetId, newBet);
  }
};
